export default __webpack_public_path__ + "locales/fr/ResetApplicationDialog.json?hash=409ea1ccd5a2963479224cd01d9096cc";